import { List, Map } from 'immutable'
import { v4 as uuid } from 'uuid'
import { PREVIEW_PAGE_ID } from '../constants/PREVIEW_PAGE_ID'

/**
 *
 * @param {*} state Store state
 * @param {*} type UID Type: e - element, s - style, p - page, c - condition
 */
export const getUID = (state, isPreview = false) => {
  let lastID = state.getIn(getIDCounterPath(isPreview), 0)

  return {
    genID: (type) => {
      lastID++
      return `${type}${isPreview ? 'dp' : ''}${lastID}`
    },
    get lastID() {
      return lastID
    },
    isPreview,
  }
}

export const getIDCounterPath = (isPreview = false) =>
  isPreview ? ['pages', PREVIEW_PAGE_ID, 'lastID'] : ['project', 'Settings', 'lastID']

/**
 * Get the current lastID from Redux state without incrementing
 * @param {*} state Store state (Immutable)
 * @param {boolean} isPreview Whether this is for preview mode
 * @returns {number} Current lastID value
 */
export const getCurrentLastID = (state, isPreview = false) => {
  return state.getIn(getIDCounterPath(isPreview), 0)
}

/**
 * Increment the lastID counter in Redux state by 1
 * @param {*} state Store state (Immutable)
 * @param {boolean} isPreview Whether this is for preview mode
 * @returns {*} Updated state with incremented lastID
 */
export const incrementLastID = (state, isPreview = false) => {
  const currentLastID = getCurrentLastID(state, isPreview)
  return state.setIn(getIDCounterPath(isPreview), currentLastID + 1)
}
